<template>
    <el-dialog
        :visible.sync="endAddressVisible"
        :show-close="false"
        center
        width="914px"
        class="end_modal"
        :before-close="handleClose">
        <div class="end_modal_title">
            选择收件人地址
            <el-button type="primary" size="mini" style="float:right" @click="goAddress">新增收件人地址</el-button>
        </div>
        <div class="end_modal_box clearfix">
            <div v-for="(item,index) in addressList" @click="selectRadio(item)" :key="index" class="end_modal_box_flex">
               <el-radio class="end_modal_radio" :value="item.id" v-model="radio" :label="item.id"><span></span></el-radio>
               <div class="end_modal_content">
                   <div class="end_modal_content_top">
                        <div class="end_modal_content_top_title" v-if="tabId == 2">
                            <span style="margin-right:10px">{{item.province + item.city + item.district}}</span>
                        </div>
                        <div class="end_modal_content_top_title" v-if="tabId == 1">
                            <span style="margin-right:10px">{{item.contacts_name}}</span>
                            <span>{{item.contacts_phone}}</span>
                        </div>
                    </div>
                    <div class="end_modal_content_bottom">
                        <div class="end_modal_content_bottom_title">
                            <span>{{item.owner_name}}</span>
                            <span>{{item.province + item.city + item.district + item.detalied_address}}</span>
                        </div>
                    </div>
               </div>
               
           </div>
        </div>
        <div class="common_pagination">
            <el-pagination
                background
                layout="prev, pager, next"
                :pager-count="9"
                @current-change="handleCurrentChange"
                :current-page="pageNumber"
                :page-size="pageSize"
                :total="total">
            </el-pagination>
            <div class="common_pagination_right">
                <div class="common_pagination_right_num"><span>{{pageNumber}}</span>/{{lastPage}}</div>
                <div class="common_pagination_right_input">
                    到第
                    <el-input v-model="pageNumberInput" size="small" style="width:63px"></el-input>
                    页
                </div>
                <div class="common_pagination_right_btn">
                    <el-button size="small" @click="changeNumberInput">确定</el-button>
                </div>
            </div>
            
        </div>
        <div class="end_modal_btn">
            <el-button type="primary" @click="selectAddress">确认选择</el-button>
        </div>
    </el-dialog>
   
</template>

<script>
export default {
    props:["endAddressVisible","endCallback"],
   data (){
       return {
           tabId:2,
           radio:'',
           addressList:[],
           loading:false,
            pageNumber:1,
            pageNumberInput:1,
            pageSize:10,
            total:0,
            lastPage:0,
           
       }
   },
   components: {
       
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       goAddress(){
           this.$router.push({
               name:'address',
               params:{type:2}
           });
       },
       selectRadio(item){
           this.radio = item.id;
       },
        //    切换页码
        handleCurrentChange(val){
            this.pageNumber = val;
            this.pageNumberInput = val;
            this.getAddressList();
        },
        // 手动输入页码后确定
        changeNumberInput(){
            if(parseInt(this.pageNumberInput) > this.lastPage){
                this.$message.error('当前页码大于总页码！');
                return 
            }
            this.pageNumber = parseInt(this.pageNumberInput);
            this.getAddressList();
        },
       selectAddress(){
           let findIndex = _.findIndex(this.addressList , item => {
               return item.id == this.radio;
           });
        //    console.log(findIndex);
           if(findIndex != -1){
               this.endCallback(this.addressList[findIndex]);
            //    this.$emit('endCallback',);
           }else{
               this.$message.error('请选择地址！');
           }
       },
       handleClose(){
           this.$emit('update:endAddressVisible',false);
       },
       getAddressList(){
           this.addressList = [];
           this.loading = true;
           this.$get('Address',{type:this.tabId,page_index:this.pageNumber,page_size:this.pageSize})
            .then(data => {
                this.addressList = data.data;
                this.total = data.total;
                this.lastPage = data.last_page;
                this.loading = false;
            }, error => {
                this.loading = false;
                this.$message.error(error);
            });;
       }
   },
   created() {
       this.getAddressList();
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.end_modal{
    
    /deep/ .el-dialog__header{
        display: none;
    }
    .end_modal_radio{
        position: relative;
        top:12px;
    }
    /deep/ .el-radio{
        margin-right: 0;
    }
    .end_modal_box_flex{
        width:420px;
        display: inline-block;
        display: flex;
        align-items: center;
        flex-wrap:nowrap;
        cursor: pointer;
        margin-right: 20px;
        float: left;
    }
    .end_modal_box{
        width:880px;
        
    }
    &_content{
        padding: 20px;
        width:420px;
        margin-top: 20px;
        background: #F7F9FC;
        &_top{
            display: flex;
            justify-content:space-between;
            align-items: center;
            &_title{
                font-size: 18px;
                font-weight: 600;
                line-height: 18px;
            }
            &_action{
                display: flex;

                &_edit{
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    margin-left:20px;
                    img{
                        width:20px;
                    }
                    span{
                        font-size: 16px;
                        color:#A6AEC1;
                    }
                }
                

            }
        }
        &_bottom{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top:16px;
            height: 40px;
            &_title{
                span{
                    font-size: 14px;
                    color:#666666;
                    margin-right: 10px;
                }
            }
            &_action{
                /deep/ .el-radio__label{
                    color:#A6AEC1;
                }
                /deep/ .el-radio .el-radio__inner{
                    border-color:#A6AEC1;
                    background: transparent;
                }
                /deep/ .el-radio.is-checked .el-radio__inner{
                    background: #409EFF;
                    border-color: #DCDFE6;
                }
            }
        }
    }
    &_title{
        font-size: 20px;
        color:#333;
        font-weight: 500;
        height: 28px;
        line-height: 28px;
        text-align: center;
    }
    &_btn{
        text-align:center;
        margin-top:40px;
        /deep/ .el-button{
            height: 36px;
            padding: 10px 16px;
            margin-left: 5px;
            font-size: 16px;
            font-weight: 400;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/components/endAddress.vue